import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { IMassMailServerSetting } from "./MassMailServerSettingTable";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { AddServer } from "./AddServer";

interface IProps {
    reload: boolean,
    setReload: (reload: boolean) => void,
    toast: any,
}

export const MassMailServerSettingForm = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false, } as { tableData: Array<IMassMailServerSetting>; loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [reload2, setReload2] = useState<boolean>(false);
    const [newForm, setNewForm] = useState<boolean>(false);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("MassMail/getMassMailServerSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailServerSetting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const toggleStatus = async (data: IMassMailServerSetting) => {
        setLoading(true);
        delete data.updated_By;
        const response = await Fetch("MassMail/updateMassMailServerStatusSetting", "PUT", data, null, props.toast);
        if (response) {
            loadTableData();
            setLoading(false);
        } else setLoading(false);
    };

    const onsubmit = async () => {
        setLoading(true);
        const newData: any = tableData.tableData.map((el: IMassMailServerSetting) => {
            return {
                id: el.id,
                Server_Name: el.server_Name,
                Server_Email: el.server_Email,
                Server_Password: el.server_Password,
                Server_Port: el.server_Port,
                Server_Max_Limit: el.server_Max_Limit,
            };
        });
        const method = "PUT";
        const message = "Updated Successfully";
        setLoading(true);

        const resp = await Fetch("MassMail/updateMassMailServerSetting", method, newData, null, null);
        if (resp) {
            props.toast.current.show({ severity: "success", detail: message, life: 3000, });
            props.setReload(!props.reload);
            setLoading(false);
        } else setLoading(false);
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const onCellEditComplete = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'server_Max_Limit':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };
        setTableData(prev => {
            const updatedData = prev.tableData.map(item => {
                if (item.id === rowData.id) {
                    return {
                        ...item, server_Max_Limit: rowData.server_Max_Limit,
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const onCellEditComplete2 = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'server_Name':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };
        setTableData(prev => {
            const updatedData = prev.tableData.map(item => {
                if (item.id === rowData.id) {
                    return {
                        ...item, server_Name: rowData.server_Name,
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const onCellEditComplete5 = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'server_Email':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };
        setTableData(prev => {
            const updatedData = prev.tableData.map(item => {
                if (item.id === rowData.id) {
                    return {
                        ...item, server_Email: rowData.server_Email,
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };


    const onCellEditComplete3 = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'server_Password':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };
        setTableData(prev => {
            const updatedData = prev.tableData.map(item => {
                if (item.id === rowData.id) {
                    return {
                        ...item, server_Password: rowData.server_Password,
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const onCellEditComplete4 = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'server_Port':
                if (newValue) rowData[field] = newValue;
                else event.preventDefault();
                break;
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };
        setTableData(prev => {
            const updatedData = prev.tableData.map(item => {
                if (item.id === rowData.id) {
                    return {
                        ...item, server_Port: rowData.server_Port,
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };
        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', cursor: "pointer" }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    const cellEditorString = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };
        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', cursor: "pointer" }} value={options.value} type='string' onChange={(e) => handleChange(e)} />
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="my-2">
                <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => setNewForm(true)} />
            </div>
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload, reload2]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="server_Name" header="Server Name" editor={(options) => cellEditorString(options)} onCellEditComplete={onCellEditComplete2} />
                <Column field="server_Email" header="Server Email" editor={(options) => cellEditorString(options)} onCellEditComplete={onCellEditComplete5} />
                <Column field="server_Password" header="Server Password" editor={(options) => cellEditorString(options)} onCellEditComplete={onCellEditComplete3} />
                <Column field="server_Port" header="Server Port" editor={(options) => cellEditorString(options)} onCellEditComplete={onCellEditComplete4} />
                <Column field="server_Max_Limit" header="Server Per Day Max Limit" body={(rowData: IMassMailServerSetting) => <p>{rowData.server_Max_Limit}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="server_Limit_Used" header="Server Todays Limit Is Used" />
                <Column field="server_Status" header="Server Status" body={(rowData: IMassMailServerSetting) => <p className="cursor-pointer" onClick={() => toggleStatus(rowData)} style={{ color: (rowData.server_Status === true ? "green" : "red") }}>{rowData.server_Status === true ? "Active" : "InActive"}</p>} />
                <Column field="server_InUse_Status" header="Server In Use Status" body={(rowData: IMassMailServerSetting) => <p style={{ color: (rowData.server_Status === true ? "green" : "red") }}>{rowData.server_Status === true ? "Yes" : "No"}</p>} />
                <Column field="updated_By" header="updated_By" />
            </DataTable>
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="button" onClick={() => {
                    if (tableData.tableData.length > 0) {
                        onsubmit();
                    }
                }} ></Button>
            </div>
            <AddServer open={newForm} reload2={reload2} setReload2={setReload2} hideDialog={() => setNewForm(false)} toast={props.toast} />
        </>
    );
}